import React, { useState } from "react";

import SelectBox from "./SelectBox";

const LanguageSelector = () => {
  const languages = [
    { code: "en", lang: "English" },
    { code: "nl", lang: "Dutch" },
    { code: "de", lang: "German" },
  ];

  const [defaultSelect, setDefaultSelect] = useState(null);

  return (
    <SelectBox
      options={languages}
      defaultSelect={defaultSelect}
      setDefault={setDefaultSelect}
    // setnav={openNav}
    />
  );
};

export default LanguageSelector;
